module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/library/modules/_is-object.js
// module id = 3
// module chunks = 0 1